import './App.css';

export function App() {
  return (
    <>
      <div className="portfolio">
        <div className='headshot rounded-full mx-auto w-1/2 text-center'>
          <img src='https://irosenb-portfolio.s3.us-west-2.amazonaws.com/isaac-pic.jpeg' alt='Isaac' className='rounded-full inline-block mr-4 ml-5 h-16 w-48 h-48'/>
        </div>
        <h2>Isaac Rosenberg</h2>
        <p className='text-2xl'>I'm an urban planner and technologist passionate about building better, more affordable cities.</p>
        <p className='text-lg'>See my work below.</p>
        <div className="directory mt-20 flex justify-center space-x-5">
          <a href="/graphing">Graphing</a>
          <a href="/tech">Technology</a>
          <a href="/writing">Writing</a>
          <a href="/gis">GIS</a>
          <a href="/graphics">Graphics</a>
          <a href="/work">Professional Work</a>
        </div>
      </div>  
    </>
  );
}
